<template>
  <b-modal
    id="modalUploadImage"
    modal-class="dialog-1000"
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
  >
  <template #modal-title>
      <h3>Imagen</h3>
  </template>

      <b-tabs align="left" class="tab-primary">
          <b-tab>
          <template #title>
            <div class="tab-title">
            <span>{{$t('Librería')}}</span>
            </div>
          </template>
          <b-card>
              <upload-image-library @saveImage="saveImage"/>
          </b-card>
        </b-tab>
        <b-tab>
          <template #title>
            <div>
            <span> {{$t('Subir')}} </span>
            </div>
          </template>
          <b-card>
            <upload-image-personalize @saveImage="saveImage"/>
          </b-card>
        </b-tab>
      </b-tabs>
  </b-modal>
</template>
<script>
import UploadImagePersonalize from '../components/UploadImagePersonalize.vue'
import UploadImageLibrary from '../components/UploadImageLibrary.vue'
export default {
  components: {UploadImagePersonalize, UploadImageLibrary},
  methods: {
    saveImage (image) {
      this.$emit('setImageForm', image)
      this.$bvModal.hide('modalUploadImage')
    }
  }
}
</script>
